import { useQuery } from '@tanstack/react-query';
import { useRepository } from '@city-sage/aurum-avis-labs-components';
import { QueryKeys } from '../lib/QueryKeys';
import { filterStops } from '../lib/stopHelper';
import { StopStateEnum } from '@city-sage/core-client';

interface UseDayStopsProps {
  itineraryId: string;
  dayId: string;
  states?: StopStateEnum[];
}

export function useDayStops({ itineraryId, dayId, states }: UseDayStopsProps) {
  const { api } = useRepository();

  const { data: day } = useQuery({
    queryKey: QueryKeys.itinerary.day(itineraryId, dayId),
    queryFn: () =>
      api.findOneItineraryDay({ id: dayId!, itineraryId: itineraryId }),
    enabled: !!itineraryId && !!dayId,
  });

  const filter = { dayIds: [dayId] };

  const filterString = states
    ? JSON.stringify({ ...filter, state: states })
    : JSON.stringify(filter);

  return useQuery({
    queryKey: QueryKeys.itinerary.stops(itineraryId, dayId, states),
    queryFn: () => {
      return api.findAllItineraryStop({
        itineraryId: itineraryId,
        sort: JSON.stringify(['index', 'ASC']),
        filter: filterString,
        // TODO this is hardcoded for now, we need to fix this
        limit: 1000,
      });
    },
    enabled: !!itineraryId && !!dayId && !!day,
  });
}
